// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function BookRibbon(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "BookRibbon" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 4C4.5 3.44772 4.94772 3 5.5 3H19.5V19H6C5.72386 19 5.5 19.2239 5.5 19.5C5.5 19.7761 5.72386 20 6 20H19.5L18.625 21H5.5C4.94772 21 4.5 20.5523 4.5 20V4ZM15.5 4.5L9.5 4.4998V13L12.5 11.6641L15.5 13V4.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=BookRibbon.js.map